import React from "react";
import {
  InputGroup,
  Input,
  InputRightElement,
  Badge,
  VStack,
  FormLabel,
  useBreakpointValue,
} from "@chakra-ui/react";

const LocationInput = ({ value, onChange, badgeState, isInvalid = false }) => {
  const inputSize = useBreakpointValue({ base: "sm", md: "md" });
  const getBadgeProps = (state) => {
    switch (state) {
      case "in":
        return { colorScheme: "gray", children: "Occupied" };
      case "out":
        return { colorScheme: "green", children: "Empty" };
      case "error":
        return { colorScheme: "red", children: "Invalid" };
      default:
        return null;
    }
  };

  return (
    <VStack spacing={1} width="100%">
      <FormLabel marginTop="5px" textAlign="center" marginBottom="5px" fontSize={{ base: "sm", md: "md" }} color={isInvalid ? "red.500" : undefined}>
        Location
      </FormLabel>
      <InputGroup size={inputSize}>
        <Input
          required
          value={value}
          type="text"
          bg="white"
          width="100%"
          placeholder="Enter Location"
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          isInvalid={isInvalid}
          autoComplete="off"
        />
        <InputRightElement width="auto" marginRight="5px">
          {badgeState && <Badge {...getBadgeProps(badgeState)} p="2" />}
        </InputRightElement>
      </InputGroup>
    </VStack>
  );
};

export default LocationInput;
